var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBookmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColour",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.328 2.993a1 1 0 00-.707.293L3.307 13.599a1 1 0 000 1.415l5.657 5.656a1 1 0 001.414 0l10.314-10.313a1 1 0 00.293-.708V3.993a1 1 0 00-1-1h-5.657zm.33 1.16a.5.5 0 00-.353.146L4.622 13.98a.5.5 0 000 .707l4.667 4.667a.5.5 0 00.707 0l9.683-9.682a.5.5 0 00.146-.354V4.652a.5.5 0 00-.5-.5h-4.667zm-.065 5.232a2 2 0 102.828-2.829 2 2 0 00-2.828 2.829zm2.12-.707A1 1 0 1115.3 7.263a1 1 0 011.414 1.415z"
  })));
}

export default SvgBookmark;